export abstract class DataService {
    abstract getData(): string;
}
